export const formatProvider = (provider: string): string =>  {
  const formattedProvider = provider?.trim()?.toLowerCase();
  if (formattedProvider === 'mycentral') return 'mycentral-soap';
  return formattedProvider;
}
  